export default __webpack_public_path__ + "static/media/Anuphan-SemiBold.7eb174dd.otf";